
const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/9c863003ff2a45a7fdb4b616e355a476/83a4210232d56303cd212f2c5e8ac070.png" 
                alt="ProArk Haven Logo" 
                className="h-12 w-auto"
              />
            </a>
            <a 
              href="/"
              className="bg-orange-600 text-white px-6 py-2 rounded-full hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Back to Home
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-8">
            <strong>Last Updated:</strong> December 2024
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700">
              By enrolling in or using the services of ProArk Haven Adult Day Care and Recreation Center, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Services Provided</h2>
            <p className="text-gray-700 mb-4">
              ProArk Haven provides adult day care and recreational services for seniors, including but not limited to:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Daily care and supervision</li>
              <li>Social and recreational activities</li>
              <li>Nutritious meals and snacks</li>
              <li>Health monitoring and medication assistance</li>
              <li>Transportation services (where available)</li>
              <li>Personal care assistance</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Enrollment and Admission</h2>
            <p className="text-gray-700 mb-4">
              Enrollment in our programs requires:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Completion of all required forms and assessments</li>
              <li>Medical clearance from a healthcare provider</li>
              <li>Payment of required fees and deposits</li>
              <li>Agreement to follow all center policies and procedures</li>
            </ul>
            <p className="text-gray-700">
              We reserve the right to refuse admission or discontinue services if we determine that we cannot adequately meet a participant's needs or if safety concerns arise.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Payment Terms</h2>
            <p className="text-gray-700 mb-4">
              Payment terms include:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Fees are due in advance according to your payment schedule</li>
              <li>Late payments may result in suspension of services</li>
              <li>Refunds are provided according to our refund policy</li>
              <li>Fee changes will be communicated with 30 days notice</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Participant Responsibilities</h2>
            <p className="text-gray-700 mb-4">
              Participants and their families are responsible for:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Providing accurate and complete information</li>
              <li>Following center rules and policies</li>
              <li>Treating staff and other participants with respect</li>
              <li>Notifying us of any changes in health status or medications</li>
              <li>Arriving and departing according to scheduled times</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Health and Safety</h2>
            <p className="text-gray-700 mb-4">
              For the safety and well-being of all participants:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Participants must be free from contagious illnesses</li>
              <li>All medications must be properly labeled and documented</li>
              <li>Emergency contact information must be current</li>
              <li>We reserve the right to seek emergency medical care when necessary</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-700">
              While we take every precaution to ensure participant safety, ProArk Haven's liability is limited to the extent permitted by law. We are not responsible for personal property loss or damage, except in cases of gross negligence.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Termination of Services</h2>
            <p className="text-gray-700 mb-4">
              Services may be terminated by either party with appropriate notice. We reserve the right to immediately terminate services if:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Payment obligations are not met</li>
              <li>Participant behavior poses a safety risk</li>
              <li>Our facility cannot adequately meet participant needs</li>
              <li>Terms of service are violated</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Privacy and Confidentiality</h2>
            <p className="text-gray-700">
              We are committed to protecting participant privacy and maintaining confidentiality in accordance with applicable laws and our Privacy Policy. Information will only be shared with authorized individuals and as required by law.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              For questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>ProArk Haven Adult Day Care and Recreation Center</strong></p>
              <p className="text-gray-700 mb-2">222 McIntyre Street West, #510B</p>
              <p className="text-gray-700 mb-2">North Bay, Ontario P1B 2Y8</p>
              <p className="text-gray-700 mb-2">Phone: 705.667.1780</p>
              <p className="text-gray-700">Email: admin@proarkhaven.ca</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Changes to Terms</h2>
            <p className="text-gray-700">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective upon posting on our website or notification to participants. Continued use of our services constitutes acceptance of any changes.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © 2024 ProArk Haven Adult Day Care and Recreation Center. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;
